<template>
  <div class="d-flex align-center">
    <span class="mr-2 text-no-wrap text-caption">
      {{ label ? label + ' ' + battery : battery }}% battery
    </span>
    <div
      class="rounded-pill bg-grey-lighten-3 flex-grow-1 flex-shrink-1"
      :style="`
        width: 100%;
        height: ${dense ? '12px' : '18px'};
        box-shadow: inset -2px 3px 2px rgba(0, 0, 0, 0.2);
        overflow: hidden;`"
    >
      <div
        class="bg-primary rounded-pill"
        :style="{ width: `${Math.max(battery, 1)}%`, height: '100%', minWidth: '18px' }"
      ></div>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  battery: number
  label?: string
  dense?: boolean
}

const { battery = 0, label, dense = false } = defineProps<Props>()
</script>
